import imageData from "../data/imageData.json";
import "./styles/CertificationSection.css";
import ResponsiveImage from "./ResponsiveImage";


const CertificationsSection = () => {
    return (
        <div className="certificationsSection">
            <h2>Certificări ISO</h2>
            <div className="certificationsRow">
            {imageData.certifications.map((certification, index) => (
                <div className="certification" key={index}>
                    <ResponsiveImage
                        src={certification.url}
                        alt={certification.alt}
                        className="certificationImage"
                        sizes="(max-width: 768px) 80vw, 300px"
                    />
                    <div className="certificationText">
                        <p>{certification.title}</p>
                    </div>
                </div>))}
            </div>
        </div>
    )
}

export default CertificationsSection;
